import { Dialog } from "components/ui/dialog";
import ViewPostContent from "./ViewPostContent";

interface PostModalProps {
  isOpen: boolean;
  postId: string | null;
  onClose: () => void;
}

export default function ViewPostModal({
  isOpen,
  postId,
  onClose,
}: PostModalProps) {
  if (!postId) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <div className="fixed inset-0 bg-background z-50">
        <ViewPostContent postId={postId!} onClose={onClose} />
      </div>
    </Dialog>
  );
}

